<template>
  <div>
    <p v-if="educationNameText" class="text-grey-body">{{ educationNameText }}</p>
    <p v-if="educationSubText" class="text-grey-body flex text-small items-center mt-8">{{ educationSubText }}</p>
  </div>
</template>

<script lang="ts">
interface Education {
  schoolName?: string;
  yearGraduated?: string | null;
  levelOfEducation?: string | null;
  major?: string;
  currentlyAttending?: boolean;
}

export default {
  name: 'ProfileEducation',
  props: {
    education: {
      type: Object as () => Education,
      default: () => ({}),
    },
    careType: {
      type: String,
      required: true,
    },
  },
  computed: {
    educationNameText(): string | null {
      const { schoolName, yearGraduated } = this.education as Education;
      if (schoolName) {
        if ((this.careType as string) === 'housekeeping') {
          return schoolName;
        }
        return yearGraduated !== 'Select' && yearGraduated !== null ? `${schoolName} (${yearGraduated})` : schoolName;
      }
      return null;
    },
    educationSubText(): string | null {
      const { schoolName, levelOfEducation, yearGraduated, major, currentlyAttending } = this.education as Education;

      if (!schoolName || (this.careType as string) === 'housekeeping') {
        return null;
      }

      if (levelOfEducation === 'graduate_degree') {
        if (yearGraduated) {
          return major !== '' ? `Graduate degree in ${major}` : 'Graduate degree';
        }
        return `Graduate Program, ${major}`;
      }

      if (yearGraduated) {
        return major !== '' ? `Degree in ${major}` : 'Degree received';
      }

      if (currentlyAttending && major !== '') {
        return `Majoring in ${major}`;
      }

      return null;
    },
  },
};
</script>
